<div class="family-container-root">
  <div class="title">{{ labels.title }}</div>
  <app-family-list></app-family-list>
  <div class="footer-button">
    <app-icon-button v2 icon="add_circle_outline" (clickAction)="addNewFamilyOpenDialog()"> {{labels.addFamilyBtn}} </app-icon-button>
  </div>
</div>
